module.exports = __webpack_public_path__ + "img/f8bc670.png";